<template>
  <div class="d-flex align-items-center gap-2">
    <!-- Boutons mode -->
    <div class="btn-group btn-group-sm" role="group">
      <button type="button" class="btn btn-sm" :class="periodeStore.mode === 'annee' ? 'btn-primary' : 'btn-outline-secondary'" @click="changerMode('annee')" title="Par année">
        <i class="material-symbols-outlined" style="font-size:14px;vertical-align:middle">calendar_today</i>
      </button>
      <button type="button" class="btn btn-sm" :class="periodeStore.mode === 'plage' ? 'btn-primary' : 'btn-outline-secondary'" @click="changerMode('plage')" title="Plage libre">
        <i class="material-symbols-outlined" style="font-size:14px;vertical-align:middle">date_range</i>
      </button>
      <button type="button" class="btn btn-sm" :class="periodeStore.mode === 'tout' ? 'btn-primary' : 'btn-outline-secondary'" @click="changerMode('tout')" title="Tout l'historique">
        <i class="material-symbols-outlined" style="font-size:14px;vertical-align:middle">all_inclusive</i>
      </button>
    </div>

    <!-- Année -->
    <select
      v-if="periodeStore.mode === 'annee'"
      :value="periodeStore.annee"
      @change="periodeStore.annee = +($event.target as HTMLSelectElement).value"
      class="form-select form-select-sm"
      style="width:75px;height:32px;padding:2px 6px;font-size:13px"
    >
      <option v-for="a in annees" :key="a" :value="a">{{ a }}</option>
    </select>

    <!-- Plage -->
    <div v-if="periodeStore.mode === 'plage'" class="d-flex align-items-center gap-1">
      <div style="width:130px">
        <VueDatePicker
          v-model="dateDebut"
          :enable-time-picker="false"
          format="dd/MM/yyyy"
          placeholder="Début"
          :clearable="false"
          auto-apply
          @update:model-value="onDebutChange"
        />
      </div>
      <span class="text-secondary" style="font-size:12px">→</span>
      <div style="width:130px">
        <VueDatePicker
          v-model="dateFin"
          :enable-time-picker="false"
          format="dd/MM/yyyy"
          placeholder="Fin"
          :clearable="false"
          :min-date="dateDebut ?? undefined"
          auto-apply
          @update:model-value="onFinChange"
        />
      </div>
    </div>

    <!-- Tout -->
    <span v-if="periodeStore.mode === 'tout'" class="badge bg-info bg-opacity-10 text-info fw-medium fs-11 px-2">
      Tout
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import { usePeriodeStore } from "@/stores/periode.store";
import { useDashboardStore } from "@/stores/dashboard.store";
import { VueDatePicker } from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

export default defineComponent({
  name: "PeriodeFilter",
  components: { VueDatePicker },
  setup() {
    const periodeStore  = usePeriodeStore();
    const dashboardStore = useDashboardStore();

    const anneeActuelle = new Date().getFullYear();
    const annees = computed(() => {
      const dispo = dashboardStore.meta?.annees_dispo ?? [];
      return dispo.length ? dispo : [anneeActuelle, anneeActuelle - 1, anneeActuelle - 2, anneeActuelle - 3, anneeActuelle - 4];
    });

    const dateDebut = ref<Date | null>(null);
    const dateFin   = ref<Date | null>(null);

    function toISO(d: Date | null) {
      return d ? d.toISOString().split("T")[0] : "";
    }

    function changerMode(mode: "annee" | "plage" | "tout") {
      periodeStore.mode = mode;
    }

    function onDebutChange(val: Date | null) {
      dateDebut.value = val;
      if (val && dateFin.value) {
        periodeStore.date_debut = toISO(val);
        periodeStore.date_fin   = toISO(dateFin.value);
      }
    }

    function onFinChange(val: Date | null) {
      dateFin.value = val;
      if (dateDebut.value && val) {
        periodeStore.date_debut = toISO(dateDebut.value);
        periodeStore.date_fin   = toISO(val);
      }
    }

    return { periodeStore, annees, dateDebut, dateFin, changerMode, onDebutChange, onFinChange };
  },
});
</script>
